export enum PostPrivacy {
    Public = "PUBLIC",
    XRated = "X_RATED",
    InnerCircle = "INNER_CIRCLE",
}